import { Component, ContentChild, Input, TemplateRef } from "@angular/core";
import { Cls_TableColumns } from "../models";

@Component({
    selector: "mobi-office-lib-dynamic-table",
    templateUrl: "./dynamic-table.component.html",
    styleUrls: ["./dynamic-table.component.scss"],
    standalone: false
})
export class DynamicTableComponent {
  @Input() headerList: Cls_TableColumns[] = [];
  @Input() masterList: any[] = [];

  @Input() customHeaderCss: string = "";
  @Input() customBodyCss: string = "";

  @ContentChild("header", { static: false }) headerTemplateRef!: TemplateRef<any>;
  @ContentChild("body", { static: false }) bodyTemplateRef!: TemplateRef<any>;
}
